module.exports = __webpack_public_path__ + "img/gnu_main0.d831b3af.jpg";